// Schema.org graph for the founder page. CommonJS so the build plugin
// (plugins/static-seo-pages.js) can embed the same JSON-LD in the static HTML.
const seo = require("../i18n/founderSeo.json");

const sameAs = (owner) => seo.socials.filter((s) => s.owner === owner).map((s) => s.url);

const founderJsonLd = (lang) => {
  const site = seo.siteUrl;
  const c = seo[lang];
  const url = `${site}${seo.paths[lang]}`;
  const personId = `${site}${seo.paths.it}#person`;
  const orgId = `${site}/#organization`;
  const photo = { "@type": "ImageObject", url: `${site}${seo.photo.jpg}`, width: seo.photo.width, height: seo.photo.height, caption: c.photoAlt };
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Person",
        "@id": personId,
        name: "Abdelouahed El Allali",
        alternateName: "Abdul",
        jobTitle: "Founder & CEO",
        description: c.desc,
        url: `${site}${seo.paths.it}`,
        image: photo,
        birthPlace: { "@type": "Country", name: "Morocco" },
        knowsAbout: c.knowsAbout,
        knowsLanguage: ["it", "en", "es"].filter((l) => seo.paths[l]),
        hasCredential: seo.credentials.map((name) => ({
          "@type": "EducationalOccupationalCredential",
          name,
          credentialCategory: c.credentialCategory,
          recognizedBy: { "@type": "Organization", name: seo.credentialIssuer },
        })),
        worksFor: { "@id": orgId },
        sameAs: sameAs("person"),
      },
      {
        "@type": "Organization",
        "@id": orgId,
        name: "SYNRISE",
        alternateName: "SYNrise",
        url: `${site}/`,
        logo: `${site}/icons/icon-512.png`,
        slogan: "Rinasci. Evolvi. Investi.",
        founder: { "@id": personId },
        sameAs: ["https://synrise.pro", ...sameAs("organization")],
      },
      {
        "@type": "ProfilePage",
        "@id": `${url}#webpage`,
        url,
        name: c.title,
        description: c.desc,
        inLanguage: lang,
        primaryImageOfPage: photo,
        isPartOf: { "@type": "WebSite", "@id": `${site}/#website`, url: `${site}/`, name: "SYNrise", publisher: { "@id": orgId } },
        about: { "@id": personId },
        mainEntity: { "@id": personId },
      },
    ],
  };
};

module.exports = { founderJsonLd };
